module.exports = __webpack_public_path__ + "media/soundtrack.967d257e.mp3";